'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface FAQ {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  faqs: FAQ[];
}

const FAQSection = ({ faqs }: FAQSectionProps) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="px-6 lg:px-12 py-24 lg:py-32 bg-background">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16 lg:mb-24">
          <p className="text-xs font-cta font-semibold tracking-[0.2em] uppercase text-muted-foreground mb-4">
            Common Questions
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-headline font-bold tracking-tight text-primary">
            Frequently Asked
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-border bg-card transition-all duration-fast hover:shadow-subtle"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-6 lg:p-8 text-left transition-colors duration-fast hover:bg-muted"
              >
                <h3 className="text-lg lg:text-xl font-headline font-bold text-primary pr-8">
                  {faq.question}
                </h3>
                <Icon
                  name="ChevronDownIcon"
                  size={24}
                  className={`text-primary flex-shrink-0 transition-transform duration-fast ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>

              <div
                className={`overflow-hidden transition-all duration-medium ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 lg:px-8 pb-6 lg:pb-8">
                  <p className="text-base lg:text-lg font-body text-text-secondary leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;